export default {
    async fetchNewsletterMailingData({commit, state}, {newsletterMailingId}) {
        try {
            commit('setNewsletterMailingIsLoaded', false)
            let responseData = (await useNuxtApp().$axios.get(useNuxtApp().$apiRoute('api.newsletters.mailings.show', {mailing: newsletterMailingId}),
                {
                    params: {
                        subscriberToken: state.subscriberToken
                    }
                })).data
            commit('setNewsletterMailingData', responseData)
            commit('setNewsletterMailingIsLoaded', true)
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    showError({statusCode: 403, message: "not_found"})
                } else if (error.response.status === 403) {
                    showError({statusCode: 403, message: error.response.data?.message, data: error.response.data})
                } else if (error.response.status === 500) {
                    showError({statusCode: 500})
                }
            } else {
                console.log(error)
            }
        }
    }
}